import { useQuery } from "@tanstack/react-query";
import { FC } from "react";

import useAlerts from "@/hooks/useAlerts";
import EditReleaseInformationForm from "@/pages/DistributionSchedule/components/EditReleaseInformationForm";
import { ReleaseResource } from "@/types/resources";
import { api } from "@/utils/api";

interface Props {
  onClose: () => void;
  releaseId: number;
}

const ReleaseInformationEdit: FC<Props> = ({ onClose, releaseId }) => {
  const alerts = useAlerts();

  const { data: release } = useQuery(
    [
      "releases",
      {
        id: releaseId,
      },
    ],
    () => api.get<never, ReleaseResource>(`/v1/releases/${releaseId}`),
    {
      onError: () => {
        onClose();
        alerts.error("Failed to fetch release!");
      },
    }
  );

  if (!release) return null;

  return (
    <EditReleaseInformationForm editableRelease={release} onClose={onClose} />
  );
};

export default ReleaseInformationEdit;
